import { render } from "./SimpleDropdown.vue?vue&type=template&id=0a6ac9fc&scoped=true"
import script from "./SimpleDropdown.vue?vue&type=script&lang=js"
export * from "./SimpleDropdown.vue?vue&type=script&lang=js"

import "./SimpleDropdown.vue?vue&type=style&index=0&id=0a6ac9fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6ac9fc"]])

export default __exports__